<script setup>
// Layout wrapper for LIA Agents routes
</script>

<template>
  <div class="flex flex-col h-full w-full bg-n-background">
    <router-view />
  </div>
</template>
